module.exports = __webpack_public_path__ + "static/media/eraser-small.250e2641.svg";